import { render, staticRenderFns } from "./batch_close.vue?vue&type=template&id=7c16a802&scoped=true&"
import script from "./batch_close.vue?vue&type=script&lang=js&"
export * from "./batch_close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c16a802",
  null
  
)

export default component.exports